import { render, staticRenderFns } from "./product-desc.vue?vue&type=template&id=44dd31e6&"
import script from "./product-desc.vue?vue&type=script&lang=js&"
export * from "./product-desc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports